export class IngestionAPIModel {
  IngestionStatusAPI: string = "";
  IngestionAPI: string = "";
  IngestionDetailsAPI: string = "";
  VolumeIssueListAPI: string = "";
  GetJournalList : string = "";
  //IngestionTransAPI: string = "";
  //UploadFileAPI: string = "";
  //DownloadFileAPI: string = "";
  //DeleteIngestionTransAPI: string = "";

  DownloadFileErrorMsg: string = "";
  FailedMsg: string = "";
  SelectFileErrorMsg: string = "";
  UploadFileMsg: string = "";
  PartialUploadMsg: string = "";

  UploadFile: string = "";
  DownloadFile: string = "";
}
